function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import "./index.es133.js";
import "react";
import "react-dom";
import { isBrowser as r } from "./index.es505.js";
import "./index.es33.js";
import "./index.es134.js";
import { EMOJI_LOCALSTORAGE_KEY as o } from "./index.es216.js";

var e = /*#__PURE__*/function () {
  function e(_t) {
    var _this = this;

    _classCallCheck(this, e);

    this.key = void 0;

    this.get = function () {
      if (!r()) return null;
      var t = localStorage.getItem(_this.key);
      if (t) try {
        return JSON.parse(t);
      } catch (_unused) {
        return null;
      } else return null;
    };

    this.key = _t || o;
  }

  _createClass(e, [{
    key: "set",
    value: function set(t) {
      r() && localStorage.setItem(this.key, JSON.stringify(t));
    }
  }]);

  return e;
}();

e.instance = new e();
export { e as default };